export default {
  baseURL: "https://referenciasapi.g10.com.br",
  useFixture: false,
  recaptchaSiteKey: "6Lf5sBIeAAAAANaInXMylBzrLuVCRPC6R3LSlfXv",
};
